import React from 'react';
import PropTypes from 'prop-types';

const LoadingScreen = ({ lines }) => (
  <div className="container__loader">
    {lines.map(line => (
      <div className="skeleton__chat" key={line}>
        <div className="skeleton__chat-avatar" />
        <div className="skeleton__chat-line" />
        <div className="skeleton__chat-line" />
      </div>
    ))}
  </div>
);
LoadingScreen.propTypes = {
  lines: PropTypes.instanceOf(Array).isRequired,
};
export default LoadingScreen;
